import { EstablishmentMutationContext } from '@establishment/contexts/establishmentMutationContext';
import { useContext } from 'react';

const useEstablishmentMutation = () => {
  const context = useContext(EstablishmentMutationContext);
  if (!context) {
    throw new Error(
      'useEstablishmentMutation must be used within a EstablishmentMutationProvider',
    );
  }
  return context;
};

export default useEstablishmentMutation;
